function Location_form_city_edit(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
		filterDecoratorCity: '.js-filter-decorator-city'
    };

    this.triggers = {
	    beforeSubmit: 'i4:beforeSubmit',
	    submitAjaxSuccess: 'i4:submitAjaxSuccess',
		updateFilter: 'i4:updateFilter'
    };

    this.init = function() {
	    this.popup = i4_Popup.get(this.$element);

	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$filterDecoratorCity = $(this.selectors.filterDecoratorCity);

	    this.$formParent.on(this.triggers.beforeSubmit, (function() {
		    i4_Popup.show_loader();
		    this.popup.hide();
	    }).bind(this));

	    this.$formParent.on(this.triggers.submitAjaxSuccess, (function() {
			i4_Popup.remove_all();
			this.$filterDecoratorCity.trigger(this.triggers.updateFilter);
	    }).bind(this));
    };
}
